<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import DwzcsqBrowse from "./DwzcsqBrowse";
import DwzcsqEdit from "./DwzcsqEdit";
import DwzcsqForm from "./DwzcsqForm";
export default {
    name: "Dwzcsq",
    components: { DwzcsqBrowse, DwzcsqEdit, DwzcsqForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "DwzcsqEdit";
            } else if (this.editProps.showForm === true) {
                return "DwzcsqForm";
            } else {
                return "DwzcsqBrowse";
            }
        }
    }
};
</script>
